module.exports = __webpack_public_path__ + "static/media/icon-status-booked.1e7d0c14.svg";